import { zEntity } from "src/types/ZEntity";
import { z } from "zod";
import { zUid } from "./zUid";
import { zDisplayId } from "./ZDisplayId";

export const zPersonEntity = zEntity.extend({
  /**
   *  В нашей системе у пользователя есть !2! id
   *  Первый генерится внутри системы, а второй, по сути,
   *  является внешним id из Keycloak. userId - это как раз и есть
   *  этот внешний id.
   *  */
  displayId: zDisplayId.nullish(),
  userId: zUid,
  userLogin: z.string(),
  roleIds: zUid.array().optional(),
});

export type ZPersonEntity = z.infer<typeof zPersonEntity>;
